import { render, staticRenderFns } from "./ProjectsList.vue?vue&type=template&id=f93d10a6&scoped=true&"
import script from "./ProjectsList.vue?vue&type=script&lang=js&"
export * from "./ProjectsList.vue?vue&type=script&lang=js&"
import style0 from "./ProjectsList.vue?vue&type=style&index=0&id=f93d10a6&prod&lang=css&"
import style1 from "./ProjectsList.vue?vue&type=style&index=1&id=f93d10a6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f93d10a6",
  null
  
)

export default component.exports